export default __webpack_public_path__ + "static/media/ic_info.f334ee0a.svg";